import { formatMonthYear } from "@/helpers/utils";
import { ResultSectionProps } from "@/interfaces/result";
import { Anotation } from "../anotation/anotation.component";

interface FipeAveragesProps {
    prices: ResultSectionProps['pricesFormatted']['fipe'];
    isVehicle0km: boolean;
    isVehicleArmored: boolean;
}

export const FipeAverages = ({ isVehicle0km, isVehicleArmored, prices }: Readonly<FipeAveragesProps>) => {
    if (isVehicle0km && prices.new) return (
        <>
            <span id="fipe-price" data-testid="fipe-price">{prices.new}</span>
            <small id="ref-month" data-testid="fipe-price-ref-month">
                Mês de referência: {prices.ref_month ? formatMonthYear(prices.ref_month) : 'N/A'}
            </small>
        </>
    );

    if (
        isVehicleArmored ||
        (isVehicle0km && !prices.new) ||
        !prices.used ||
        (!prices.new && !prices.used)
    ) {
        return <Anotation text="Sem valores de referência. Veja a média Webmotors" />;
    }

    return (
        <>
            <span id="fipe-price" data-testid="fipe-price">{prices.used}</span>
            <small id="ref-month" data-testid="fipe-price-ref-month">
                Mês de referência: {prices.ref_month ? formatMonthYear(prices.ref_month) : 'N/A'}
            </small>
        </>
    );
};